import React from 'react';
import ReactDOM from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { InteractionType } from '@azure/msal-browser';
import { MsalAuthenticationTemplate, MsalProvider } from '@azure/msal-react';
import App from './App';
import FluentUiThemeProvider from './Components/Theme/FluentUiProvider';
import NotificationProvider from './Contexts/NotificationContext';
import { QueryClientProvider } from './Contexts/QueryClientProvider';
import i18n from './i18n';
import './index.css';
import StoreProvider from './store/StoreProvider';
import { loginRequest, publicClientApp } from './Security/azureAdAuthentication';
import UserContextProvider from './Contexts/UserContext';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <React.StrictMode>
      <MsalProvider instance={publicClientApp}>
        <UserContextProvider>
          <I18nextProvider i18n={i18n}>
            <QueryClientProvider>
              <StoreProvider>
                <FluentUiThemeProvider>
                  <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}  authenticationRequest={{ ...loginRequest }}>
                    <NotificationProvider>
                      <App />
                    </NotificationProvider>
                  </MsalAuthenticationTemplate>
                </FluentUiThemeProvider>
              </StoreProvider>
            </QueryClientProvider>
            </I18nextProvider>
          </UserContextProvider>
      </MsalProvider>
    </React.StrictMode>,
);
